/**
 * @generated SignedSource<<1da9d301a28e085360bee18ccbbf3d7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReactivateDiscountActionInput = {
  clientMutationId?: string | null;
  discountActionId: string;
  newDiscountTypeKind: string;
  newIsReductible: boolean;
  newPercentage: any;
  newTitle: string;
  newUsageLimitation?: UsageLimitedInput | null;
  newValidUntil?: string | null;
};
export type UsageLimitedInput = {
  maxAmountOfUsages?: number | null;
  maxAmountOfUsagesPerAccount?: number | null;
  onlyForAccountIds: ReadonlyArray<string>;
  onlyForProductIds: ReadonlyArray<string>;
};
export type discountActionForm_ReactivateDiscountActionMutation$variables = {
  input: ReactivateDiscountActionInput;
};
export type discountActionForm_ReactivateDiscountActionMutation$data = {
  readonly Admin: {
    readonly Billing: {
      readonly reactivateDiscountAction: {
        readonly edge: {
          readonly node: {
            readonly " $fragmentSpreads": FragmentRefs<"discountActionForm_DiscountActionFragment">;
          };
        };
      } | null;
    };
  };
};
export type discountActionForm_ReactivateDiscountActionMutation = {
  response: discountActionForm_ReactivateDiscountActionMutation$data;
  variables: discountActionForm_ReactivateDiscountActionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v4 = [
  (v2/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "max",
        "storageKey": null
      }
    ],
    "type": "AmountLimited",
    "abstractKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "discountActionForm_ReactivateDiscountActionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "ReactivateDiscountActionPayload",
                "kind": "LinkedField",
                "name": "reactivateDiscountAction",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DiscountActionsEdge",
                    "kind": "LinkedField",
                    "name": "edge",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DiscountAction",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "discountActionForm_DiscountActionFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "discountActionForm_ReactivateDiscountActionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "ReactivateDiscountActionPayload",
                "kind": "LinkedField",
                "name": "reactivateDiscountAction",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DiscountActionsEdge",
                    "kind": "LinkedField",
                    "name": "edge",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DiscountAction",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "percent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isReductible",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "archiveInfo",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isArchived",
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "validUntil",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "dateTime",
                                    "storageKey": null
                                  }
                                ],
                                "type": "ValidUntilDateTime",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "discountType",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "usageLimitation",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "maxAmountOfUsages",
                                    "plural": false,
                                    "selections": (v4/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "maxAmountOfUsagesPerAccount",
                                    "plural": false,
                                    "selections": (v4/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "onlyForAccountIds",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "onlyForProductIds",
                                    "storageKey": null
                                  }
                                ],
                                "type": "UsageLimited",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ef01ad78cd58dcaa89cd2fcba99c096e",
    "id": null,
    "metadata": {},
    "name": "discountActionForm_ReactivateDiscountActionMutation",
    "operationKind": "mutation",
    "text": "mutation discountActionForm_ReactivateDiscountActionMutation(\n  $input: ReactivateDiscountActionInput!\n) {\n  Admin {\n    Billing {\n      reactivateDiscountAction(input: $input) {\n        edge {\n          node {\n            ...discountActionForm_DiscountActionFragment\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment discountActionForm_DiscountActionFragment on DiscountAction {\n  id\n  title\n  percent\n  isReductible\n  archiveInfo {\n    __typename\n    isArchived\n    kind\n  }\n  validUntil {\n    __typename\n    kind\n    ... on ValidUntilDateTime {\n      dateTime\n    }\n  }\n  discountType {\n    __typename\n    kind\n  }\n  usageLimitation {\n    __typename\n    kind\n    ... on UsageLimited {\n      kind\n      maxAmountOfUsages {\n        __typename\n        ... on AmountLimited {\n          max\n        }\n      }\n      maxAmountOfUsagesPerAccount {\n        __typename\n        ... on AmountLimited {\n          max\n        }\n      }\n      onlyForAccountIds\n      onlyForProductIds\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "65ca8a8c2fee0a9273f447c2869694a5";

export default node;
